<div class="login-container">
  <!-- Left Panel -->
  <div class="left-panel">

    <div class="top-logos">
      <img src="assets/dashboard icons/logo1.png">
      <img src="assets/dashboard icons/logo2.png">
      <img class="asha-saathi-logo" src="assets/dashboard icons/ashasathilogo.png">
      <img src="assets/dashboard icons/logo4.png">
      <img src="assets/dashboard icons/logo5.png">
    </div>

    <div class="left-panel-text">
      {{ 'LOGIN.LEFT_TEXT' | translate }}
    </div>

    <img src="assets/dashboard icons/AshaPic.png" alt="Asha" />

  </div>

  <div class="right-container">
    <div class="login-card">
      <!-- Desktop logo -->
      <!-- <img src="assets/Frame6.png" width="auto" height="80px" alt="Asha" /> -->
      <!-- <div class="header-title">ASHA साथी</div> -->
      <img src="assets/icons/headericon_pink.png" alt="Asha" />

      <h2 class="login-title">{{ 'LOGIN.TITLE' | translate }}</h2>

      <!-- Mobile replacement image -->
      <!-- <img src="assets/icons/AshaSathiLogo.png" alt="Asha" class="mobile-login-image" /> -->
      <p class="login-subtitle">{{ 'LOGIN.SUBTITLE' | translate }}</p>

      <form class="login-form" (submit)="onSubmit($event)">

        <dx-form [formData]="formData" [disabled]="loading" [colCount]="1" labelLocation="top" class="custom-login-form"
          [showColonAfterLabel]="false">

          <dxi-form-item dataField="email" id="email" editorType="dxTextBox" [editorOptions]="{
              stylingMode: 'outlined',
             placeholder: ('LOGIN.USERNAME_PLACEHOLDER' | translate),
              buttons: [{
                name: 'userIcon',
                location: 'after',
                options: { icon: 'custom-user-icon' }
              }]
            }">
            <dxo-label [text]="'LOGIN.USERNAME' | translate"></dxo-label>
          </dxi-form-item>

          <dxi-form-item dataField="password" id="password" editorType="dxTextBox" [editorOptions]="{
              stylingMode: 'outlined',
               placeholder: ('LOGIN.PASSWORD_PLACEHOLDER' | translate),
              mode: passwordMode,
              buttons: [{
                name: 'togglePassword',
                location: 'after',
                options: {
                  icon: passwordMode === 'text' ? 'custom-eye-open' : 'custom-eye-close',
                  onClick: togglePasswordVisibility
                }
              }]
            }">
            <dxo-label [text]="'LOGIN.PASSWORD' | translate"></dxo-label>
            <!-- <dxi-form-validation-rule type="required" message="Password is required"></dxi-form-validation-rule> -->
          </dxi-form-item>
        </dx-form>

        <div class="forgot-password-text" style="margin-top: 2px;">
          <a (click)="NavigateForgotPassword()"> {{ 'LOGIN.FORGOT_PASSWORD' | translate }}</a>
        </div>
        <dx-button [text]="'LOGIN.BUTTON' | translate" type="default" stylingMode="contained" class="login-button"
          (click)="onSubmit($event)"></dx-button>
      </form>
    </div>
  </div>
</div>